import { useModalStateContext } from "../../../../contexts/ModalStateContext"
import CriarPedidoVendaDialog from "../../../../screens/Comercial/components/MIPedidos/DialogCriarPedidoVenda"
import { enqueueSnackbar } from "notistack"
export default function ModaisComercial() {

    const { modais, handleToggleModal } = useModalStateContext()

    return (
        <>
            {
                modais.comercial.criarPedidoVenda &&
                <CriarPedidoVendaDialog
                    open={modais.comercial.criarPedidoVenda}
                    handleClose={() => {
                        handleToggleModal("comercial", "criarPedidoVenda", false)
                    }}
                    onCreate={(codigo: string) => {
                        handleToggleModal("comercial", "criarPedidoVenda", false)
                        enqueueSnackbar(`Solicitação de pedido #${codigo} foi criada com sucesso!`, { variant: "success" })
                    }}
                    onFail={() => {
                        enqueueSnackbar(`Erro ao criar solicitação`, { variant: "error" })
                    }}
                />
            }
        </>
    )
}
